import request from "@/utils/request";

// 列表(主数据列表)
export function loadUserWorkBoardRegionListDataApi(data) {
    return request({
      url: "web/userWorkBoardRegion/listData",
      method: "post",
      data
    });
  }
  // 导出
  export function loadUserWorkBoardRegionExportDataApi(data) {
    return request({
      url: "web/userWorkBoardRegion/exportData",
      method: "post",
      data
    });
  }
  
  // 保存
  export function saveOrUpdateUserWorkBoardRegionApi(data) {
    return request({
      url: "web/userWorkBoardRegion/saveOrUpdate",
      method: "post",
      data
    });
  }
  
  // 查看
  export function initUserWorkBoardRegionApi(data) {
    return request({
      url: "web/userWorkBoardRegion/init",
      method: "post",
      data
    });
  }